/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * API for managing meeting bots, calendar integrations, and webhooks
 * OpenAPI spec version: 2.0.0
 */

/**
 * What to do if no meet_login slot is available.
- 'fail' (default): bot creation fails with meet_login_unavailable.
- 'anonymous': silently fall back to an anonymous (non-authenticated) bot.
 */
export type CreateBotRequestBodyInputMeetConfigAnyOfFallback =
  (typeof CreateBotRequestBodyInputMeetConfigAnyOfFallback)[keyof typeof CreateBotRequestBodyInputMeetConfigAnyOfFallback]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBotRequestBodyInputMeetConfigAnyOfFallback = {
  fail: "fail",
  anonymous: "anonymous"
} as const
